import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminCaseStudies() {
  const [caseStudies, setCaseStudies] = useState([]);
  const [courses, setCourses] = useState([]);
  const [title, setTitle] = useState('');
  const [pdf, setPdf] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [filterCourse, setFilterCourse] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const itemsPerPage = 10;
  const navigate = useNavigate();
  useEffect(() => {
    const loadData = async () => {
      const coursesData = await fetchCourses();
      if (coursesData) {
        await fetchCaseStudies(coursesData);
      } else {
        fetchCaseStudies();
      }
    };
    loadData();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterCourse]);
  const fetchCourses = async () => {
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in.');
        return null;
      }
      const response = await axios.get(`${apiUrl}/api/admin/courses`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setCourses(response.data.courses);
        return response.data.courses;
      } else {
        setError(response.data.message || 'Failed to fetch courses.');
        return null;
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching courses.');
      return null;
    }
  };
  const fetchCaseStudies = async (coursesData = courses) => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to manage case studies.');
        setLoading(false);
        return;
      }
      const response = await axios.get(`${apiUrl}/api/admin/case-studies`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        const withCourse = response.data.caseStudies.map(cs => ({
          ...cs,
          coursename: coursesData.find(c => c.id === cs.course_id)?.coursename || 'Unknown'
        }));
        setCaseStudies(withCourse);
      } else {
        setError(response.data.message || 'Failed to fetch case studies.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching case studies.');
    } finally {
      setLoading(false);
    }
  };
  const handlePdfChange = (e) => {
    setPdf(e.target.files[0]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const formData = new FormData();
    formData.append('title', title);
    formData.append('course_id', selectedCourse);
    formData.append('pdf', pdf);
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('Authentication required.');
        return;
      }
      const response = await axios.post(`${apiUrl}/api/admin/case-studies`, formData, {
        headers: {
          Authorization: `Bearer ${sessionData.token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.success) {
        setSuccess('Case study added successfully.');
        setTitle('');
        setPdf(null);
        document.getElementById('case-study-pdf').value = '';
        setSelectedCourse('');
        fetchCaseStudies();
      } else {
        setError(response.data.message || 'Failed to add case study.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding case study.');
    }
  };
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this case study?')) {
      try {
        const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
        const response = await axios.delete(`${apiUrl}/api/admin/case-studies/${id}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        if (response.data.success) {
          fetchCaseStudies();
        } else {
          setError(response.data.message || 'Failed to delete case study.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Error deleting case study.');
      }
    }
  };
  const handleView = (caseStudy) => {
    let filename = '';
    if (caseStudy.pdf) {
      filename = caseStudy.pdf.split('/').pop().split('\\').pop();
    }
    if (!filename) {
      alert('Error: Could not extract filename from PDF path');
      return;
    }
    const pdfUrl = `${apiUrl}/api/public/case-study-pdf?file=${encodeURIComponent(filename)}`;
    navigate('/admin-view-case-study', {
      state: {
        bookTitle: caseStudy.title,
        pdfUrl: pdfUrl,
        courseName: caseStudy.coursename
      }
    });
  };
  const filteredCaseStudies = caseStudies.filter(cs =>
    cs.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (filterCourse ? cs.course_id === parseInt(filterCourse) : true)
  );
  const isFiltered = searchTerm !== '' || filterCourse !== '';
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentCaseStudies = filteredCaseStudies.slice(indexOfFirst, indexOfLast);
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredCaseStudies.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Manage Case Studies</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Add New Case Study</h4>
              {error && <div className="alert alert-danger mb-16">{error}</div>}
              {success && <div className="alert alert-success mb-16">{success}</div>}
              <form onSubmit={handleSubmit} encType="multipart/form-data" className="mb-24">
                <div className="mb-3">
                  <label htmlFor="case-study-course" className="form-label">Course</label>
                  <select
                    className="form-control"
                    id="case-study-course"
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    required
                  >
                    <option value="">Select Course</option>
                    {courses.map(course => (
                      <option key={course.id} value={course.id}>{course.coursename}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="case-study-title" className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="case-study-title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="case-study-pdf" className="form-label">PDF File</label>
                  <input
                    type="file"
                    className="form-control"
                    id="case-study-pdf"
                    accept="application/pdf"
                    onChange={handlePdfChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Add Case Study</button>
              </form>
              <h4 className="mb-16">Case Study List</h4>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by title"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <select
                  className="form-control"
                  value={filterCourse}
                  onChange={(e) => setFilterCourse(e.target.value)}
                >
                  <option value="">All Courses</option>
                  {courses.map(course => (
                    <option key={course.id} value={course.id}>{course.coursename}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="card-body p-0 overflow-x-auto">
              {loading && (
                <div className="alert alert-info mb-0" role="alert">
                  Loading case studies...
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-0" role="alert">
                  {error}
                </div>
              )}
              {!loading && !error && filteredCaseStudies.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  {isFiltered ? 'No case studies found.' : 'No case studies added.'}
                </div>
              )}
              {!loading && !error && filteredCaseStudies.length > 0 && (
                <table id="caseStudyTable" className="table table-striped">
                  <thead>
                    <tr>
                      <th className="h6 text-gray-300">Title</th>
                      <th className="h6 text-gray-300">Course</th>
                      <th className="h6 text-gray-300">Created</th>
                      <th className="h6 text-gray-300">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentCaseStudies.map((cs) => (
                      <tr key={cs.id}>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {cs.title.length > 30 ? `${cs.title.substring(0, 30)}...` : cs.title}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {cs.coursename.length > 30 ? `${cs.coursename.substring(0, 30)}...` : cs.coursename}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {new Date(cs.created).toLocaleDateString()}
                          </span>
                        </td>
                        <td>
                          <button
                            onClick={() => handleView(cs)}
                            className="bg-main-50 text-main-600 py-2 px-14 rounded-pill hover-bg-main-600 hover-text-white"
                          >
                            View
                          </button>
                          <button
                            onClick={() => handleDelete(cs.id)}
                            className="bg-danger-50 text-danger-600 py-2 px-14 rounded-pill hover-bg-danger-600 hover-text-white ms-8"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer flex-between flex-wrap">
              <span className="text-gray-900">
                Showing {filteredCaseStudies.length === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, filteredCaseStudies.length)} of {filteredCaseStudies.length} entries
              </span>
              <ul className="pagination flex-align flex-wrap">
                {pageNumbers.map(number => (
                  <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <a
                      onClick={() => setCurrentPage(number)}
                      className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                      href="#!"
                    >
                      {number}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminCaseStudies;
